import { getAllAccounts, getAllCatalogTypes } from './actions';

export const DEFAULT_DEPARTMENTS_STATE = {
  accounts: {},
  catalogTypes: {}
};

const departmentsReducer = (state = DEFAULT_DEPARTMENTS_STATE, action) => {
  const { departments } = state;

  switch (action.type) {
    case getAllAccounts.event.success: {
      const accountIdToAccount = action.payload.reduce((acc, account) => {
        acc[account.id] = account;

        return acc;
      }, {});
      return {
        ...state,
        departments: {
          ...departments,
          accounts: accountIdToAccount
        }
      };
    }
    case getAllCatalogTypes.event.success: {
      const catalogTypeIdToCatalogType = action.payload.reduce((acc, catalogType) => {
        acc[catalogType.id] = catalogType;

        return acc;
      }, {});
      return {
        ...state,
        departments: {
          ...departments,
          catalogTypes: catalogTypeIdToCatalogType
        }
      };
    }

    default:
      return state;
  }
};

export default departmentsReducer;
